import { getAttributeValue, setAttributeValue, clearAttributeValue } from './utils';

const station = {
    state: {
        stCheck: ""
    },
    getters: {
        getStCheck(state) {
            return getAttributeValue(state, "stCheck");
        },
    },
    mutations: {
        SET_ST_CHECK: (state, stCheck) => {
            setAttributeValue(state, "stCheck", stCheck);
        },
        CLEAR_ST_CHECK: (state) => {
            state.stCheck = "";
            // 同步清除session
            clearAttributeValue("stCheck");
        }
    },
    actions: {
        setStCheck({ commit }, stCheck) {
            commit('SET_ST_CHECK', stCheck);
        },

        clearStCheck: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_ST_CHECK');
        }
    }
}

export default station


// WEBPACK FOOTER //
// ./src/store/modules/station.js